// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/kycb/acceptance/persons/firstparty/v1/create_process.proto

/* oxlint-disable */

/**
 * Request message for CreateProcess RPC.
 * Authentication is done via PASETO token (membership session).
 * All required data (person ID, market) is derived from the authenticated session context.
 */
export interface ApiCreateProcessRequest {
}

/**
 * Response message for CreateProcess RPC.
 * Returns HTTP 200 OK on success (including when an active process already exists).
 */
export interface ApiCreateProcessResponse {
  /** The organization ID associated with the membership the process was created for. */
  readonly organizationId: string;
}

/** Error definitions for CreateProcess RPC. */
export interface ApiCreateProcessErrors {
}

/** Errors returned with HTTP 404 Not Found. */
export const ApiCreateProcessErrorsNotFoundError = {
  /** NOT_FOUND_ERROR_UNSPECIFIED - Unspecified error (for forward compatibility). */
  NOT_FOUND_ERROR_UNSPECIFIED: "NOT_FOUND_ERROR_UNSPECIFIED",
  /**
   * Membership is not yet linked to a person.
   */
  membership_not_linked: "membership_not_linked",
} as const;

export type ApiCreateProcessErrorsNotFoundError =
  typeof ApiCreateProcessErrorsNotFoundError[keyof typeof ApiCreateProcessErrorsNotFoundError];

export namespace ApiCreateProcessErrorsNotFoundError {
  export type NOT_FOUND_ERROR_UNSPECIFIED = typeof ApiCreateProcessErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  export type membership_not_linked = typeof ApiCreateProcessErrorsNotFoundError.membership_not_linked;
}

export function apiCreateProcessErrorsNotFoundErrorFromJSON(object: any): ApiCreateProcessErrorsNotFoundError {
  switch (object) {
    case 0:
    case "NOT_FOUND_ERROR_UNSPECIFIED":
      return ApiCreateProcessErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
    case 1:
    case "membership_not_linked":
      return ApiCreateProcessErrorsNotFoundError.membership_not_linked;
    default:
      return ApiCreateProcessErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  }
}

export function apiCreateProcessErrorsNotFoundErrorToJSON(object: ApiCreateProcessErrorsNotFoundError): string {
  switch (object) {
    case ApiCreateProcessErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
    case ApiCreateProcessErrorsNotFoundError.membership_not_linked:
      return "membership_not_linked";
    default:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
  }
}

export const ApiCreateProcessRequest: MessageFns<ApiCreateProcessRequest> = {
  fromJSON(_: any): ApiCreateProcessRequest {
    return {};
  },

  toJSON(_: ApiCreateProcessRequest): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiCreateProcessResponse: MessageFns<ApiCreateProcessResponse> = {
  fromJSON(object: any): ApiCreateProcessResponse {
    return { organizationId: isSet(object.organizationId) ? globalThis.String(object.organizationId) : "" };
  },

  toJSON(message: ApiCreateProcessResponse): unknown {
    const obj: any = {};
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organizationId = message.organizationId;
    }
    return obj;
  },
};

export const ApiCreateProcessErrors: MessageFns<ApiCreateProcessErrors> = {
  fromJSON(_: any): ApiCreateProcessErrors {
    return {};
  },

  toJSON(_: ApiCreateProcessErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
